import { btlApplicationFormApi } from 'api/btlApplicationForm';
import { makeFormReadonly } from 'pages/BtlApplicationFormPage/makeFormReadonly';
import { useIntl } from 'react-intl';
import { mapHouseholdToOoExpensesFormValues } from './mapHouseholdToOoExpensesFormValues';
import { ooExpensesFormSchema } from './ooExpensesFormSchema';

interface UseOoCaseExpensesFormParams {
  caseId: string;
  isCaseLoading: boolean;
}

export function useOoCaseExpensesForm({ caseId, isCaseLoading }: UseOoCaseExpensesFormParams) {
  const { formatMessage } = useIntl();

  if (isCaseLoading || !caseId) {
    return { isLoading: true as const };
  }

  const schemaProps = {
    formatMessage,
    isFormEditable: false,
    isDipAccepted: true,
    isDipAcceptedOrLater: true,
  };

  const formSchema = ooExpensesFormSchema(schemaProps);

  return {
    isLoading: false as const,
    formProps: {
      columns: makeFormReadonly(formSchema),
      isFormEditable: false,
      name: 'oo_expenses',
      request: async () => {
        const households = await btlApplicationFormApi.getHouseholds(caseId);
        const household = households?.[0];

        return mapHouseholdToOoExpensesFormValues(household);
      },
    },
  };
}
